export const TRANSLATIONS_ES_MX = {
  labels: {
    show_map: "Mostrar mapa",
    submission_guideline: "Pauta de envío",
    delete_custom_documents: "Eliminar documentos personalizados",
    search_by_foundation_name: "Buscar por nombre de fundación...",
    explore_funding: "¡Explore oportunidades de financiación!",
    explore_funding_ca: "¡Explore oportunidades de financiación en Canadá!",
    watch_demo_slides: "Ver diapositivas de demostración",
    join_live_webinar: "Únase a un seminario web de preguntas y respuestas en vivo",
    register_webinar: "Regístrese para nuestro seminario web en vivo",
    roadmap_success_guide: "Guía del plan para el éxito",
    charities_helping_charities_title: "Programa de referencias: organizaciones que ayudan a organizaciones",
    you_got_funded: "¡Te han financiado! Reclama tu bono.",
    report_your_successful_grant: "Notifique su solicitud de subvención aprobada y desbloquee instantáneamente $25 en créditos de anticipo de subvención.",
    refer_charity_earn_bonus: "¡Refiere una organización y gana tiempo adicional!",
    optimal_browser_use: "Uso óptimo del navegador",
    browser_recommendation: "Para obtener la mejor experiencia, recomendamos utilizar las últimas versiones de Chrome o Firefox.",
    roadmap_success_pdf: "Plan para el éxito.pdf",
    charities_program_form: "Formulario del programa de organizaciones que ayudan a organizaciones.pdf",
    refer_a_charity: "Referir una organización",
    user_name: "Nombre de usuario",
    password: "Contraseña",
    reset_password: "Nueva contraseña",
    reset_password_confirm: "Confirmar contraseña",
    login: "Iniciar Sesión",
    sign_up: "Inscribirse",
    forgot_password: "¿Olvidaste tu contraseña?",
    go_back: "Regresa",
    organization: "Organización",
    phone: "Teléfono",
    first_name: "Primer nombre",
    last_name: "Apellido",
    address: "Dirección",
    select: "Seleccione",
    country: "País",
    complementary_address: "Dirección complementaria",
    postal_code: "Código postal",
    city: "Ciudad",
    state: "Estado",
    stateOrProvince: "Estado/Provincia",
    billing: "Facturación",
    use_same_address: "Usar la misma dirección",
    loading: "Cargando...",
    register: "Registrarse",
    message: "Mensaje",
    error: "Error",
    welcome_back: "Hola, bienvenido de nuevo",
    enter_credentials: "Ingrese sus credenciales para continuar",
    dont_have_account: "¿No tienes cuenta?",
    remember_me: "Recuérdame",
    sign_in: "Iniciar sesión",
    already_have_account: "¿Ya tienes una cuenta?",
    subscription_plan: "Plan de suscripción",
    country_billing: "Facturación del país",
    password_recovery: "Recuperación de contraseña",
    password_reset: "Restablecimiento de contraseña",
    setting_up_account: "Configuración de cuenta",
    current_password: "Contraseña actual",
    new_password: "Nueva contraseña",
    confirm_password: "Confirmar contraseña",
    confirming_account: "Confirmando cuenta",
    accounts_created: "Cuentas creadas",
    of: "de",
    or: "O",
    search: "Búsqueda",
    clear: "Limpiar",
    status: "Estado",
    actions: "Acciones",
    add_new_user: "Añadir nuevo usuario",
    edit_user: "Editar usuario",
    additional_emails: "Correos electrónicos adicionales",
    organization_letterhead: "Membrete de la organización",
    similar_charities: "Organizaciones Similares",
    similar_charities_description: "Busque organizaciones benéficas similares a la suya para que podamos encontrar financiadores que apoyen su área.",
    similar_charities_search_label: "Buscar organizaciones",
    similar_charities_search_placeholder: "Escriba el nombre de una organización...",
    similar_charities_manual_entry_hint: "¿No la encuentra en la lista? Escriba el nombre completo y presione Entrar para agregarla manualmente.",
    similar_charities_selected_count: "{{count}} seleccionada(s)",
    similar_charities_no_results: "No se encontraron organizaciones",
    similar_charities_saved: "Organizaciones similares guardadas exitosamente",
    add_similar_charities: "Agregar Organizaciones Similares",
    company_information: "Información de la Organización",
    company_organization: "Organización",
    created_at: "Creado en",
    added_by: "Agregado por",
    change_main_email: "Cambiar la dirección de correo electrónico principal",
    main_email: "Dirección de correo electrónico principal",
    emails_created: "Correos electrónicos creados",
    add_new_additional_email: "Añadir nuevo correo electrónico adicional",
    new_email_address: "Nueva dirección de correo electrónico",
    add_digital_letterhead: "Agregar membrete digital",
    select_header_style: "Seleccionar estilo de letra",
    header_only: "Solo encabezado",
    header_and_footer: "Encabezado y pie de página",
    exclude_pre_loaded: "Excluir precargado",
    email_alert: "Alerta de correo",
    signature: "Firma",
    user_letterhead: "Membrete del usuario",
    user_information: "Información del usuario",
    position: "Posición",
    enable_disable_notifications: "Activar/Desactivar notificaciones",
    user_name_or_email: "Usuario o correo electrónico",
    avg_grants_Annually: "Subvenciones promedio anuales",
    avg_grant_size: "Tamaño promedio de la subvención",
    total_assets: "Activos totales",
    summary: "Resumen",
    notes_taken: "Notas tomadas",
    last_report: "Último informe",
    not_informed: "No informado",
    loading_profile_summary: "Cargando resumen del perfil",
    amount: "Monto",
    grants: "Subvenciones",
    funders: "Financiadores",
    funders_selected: "Financiadores seleccionados",
    show_grant_details: "Mostrar detalles de la subvención",
    profile_summary: "Resumen del perfil",
    view_profile: "Ver perfil",
    year: "Año",
    avg_grants: "Subvenciones medias",
    recipient: "Beneficiario",
    territories: "Territorios",
    giving_int: {
      prefix: "Interés nacional de donación de",
      state: "Estado",
      province: "Provincia",
      territories: "Territorios",
    },
    foundation_name: "Nombre de la fundación",
    import: "Importar",
    organization_name: "Nombre de la organización",
    contact_name: "Nombre de contacto",
    state_or_province: "Estado / Provincia",
    info: "Información",
    add_funders_to_project: "Agregar financiadores al proyecto",
    add_funder_to_project: "Agregar financiador al proyecto",
    export_to_excel: "Exportar a Excel",
    block_funders: "Bloquear financiadores",
    province: "Provincia",
    databases: "Bases de datos",
    search_result: "Resultado de búsqueda",
    back_to_search: "Volver a la búsqueda",
    location: "Ubicación",
    purpose: "Propósito",
    category: "Categoría",
    sector: "Sector",
    sectors: "Sectores",
    not_provided_by: "No proporcionado por",
    keyword: "Palabra clave",
    my_list: "Mi lista",
    shared_list: "Lista compartida",
    favorite_name: "Nombre del favorito",
    select_favorite: "Seleccionar un favorito",
    close: "Cerrar",
    confirm: "Confirmar",
    description: "Descripción",
    show_saved_search: "Mostrar búsqueda guardada",
    save_regional_search: "Guardar búsqueda regional",
    save_search: "Guardar búsqueda",
    switch_to_classic: "Cambiar a clásico",
    load_selected_saved_search: "Cargar búsqueda guardada seleccionada",
    rename: "Cambiar nombre",
    remove_save_search: "Eliminar búsqueda guardada",
    updated_at: "Actualizado en",
    amt: "Monto",
    create_user_account: "Crear proyecto de usuario",
    edit_user_account: "Editar proyecto de usuario",
    name_project: "Nombre del proyecto",
    total_project_cost: "Costo total del proyecto",
    start_date: "Fecha de inicio",
    end_date: "Fecha de finalización",
    delete_project: "Eliminar proyecto",
    select_director_from_list: "Selecciona un director de la lista",
    enter_custom_director: "¿No encuentras director? Ingresa uno personalizado",
    enter_director_name: "Ingresa el nombre del director",
    select_director: "Seleccionar director",
    salutation: "Saludo",
    ask_amount: "Monto solicitado",
    total_amount: "Monto total",
    application_information: "Información de la solicitud",
    instruction: "Instrucciones",
    restriction: "Restricciones",
    deadline: "Fecha límite",
    contact: "Contacto",
    largest: "Más grande",
    average: "Promedio",
    median: "Mediana",
    remove_funder: "Eliminar financiadores",
    foundation_exists_other_projects: "Este financiador existe en otros proyectos dentro de su organización",
    remove_foundations_other_projects: "Eliminar financiadores de otros proyectos",
    application_info: "Información de la aplicación",
    this_action_will_remove: "Esta acción eliminará",
    from_this_project: "de este proyecto",
    hide_customized_funders: "Ocultar financiadores personalizados",
    project_funders: "Financiadores del proyecto",
    custom_letter: "Carta personalizada",
    change_project: "Cambiar proyecto",
    return_grant_secretary: "Volver a la Secretaría de Subvenciones",
    impact_report_letter: "Informe de impacto",
    project_funders_master_document: "Financiadores del proyecto / Documento maestro",
    master_document: "Documento maestro",
    letter_of_inquiry: "Carta de consulta",
    proposal: "Propuesta",
    thank_you_letter: "Carta de agradecimiento",
    custom_document: "Documento personalizado",
    qualify: "Calificar",
    favorites: "Favoritos",
    favorite_funders: "Financiadores favoritos",
    add_funders_to_project: "Agregar financiadores al proyecto",
    add_funder_to_project: "Agregar financiador al proyecto",
    select_one_or_more_projects: "Seleccione uno o más proyectos",
    block_funders: "Bloquear financiadores",
    print_funder_page: "Imprimir página de financiadores",
    move_to_previous_funder: "Mover al financiador anterior",
    move_to_next_funder: "Mover al siguiente financiador",
    remove_this_funder_from_qualified: "Eliminar este financiador del estado calificado y excluir de la lista de favoritos.",
    mark_funder_as_qualified: "Marcar este financiador como calificado.",
    block_funder: "Bloquear financiador",
    export_funders_to_excel: "Exportar financiadores a Excel",
    funder_name: "Nombre del financiador",
    prev: "Anterior",
    next: "Siguiente",
    previous: "Anterior",
    visit_website: "Visitar sitio web",
    notes: "Notas",
    add_note: "Agregar nota",
    company: "Empresa",
    email: "Correo electrónico",
    website: "Sitio web",
    contact_infos: "Información de contacto",
    other_infos: "Otra información",
    help_center: "Centro de ayuda",
    profile_settings: "Configuración del perfil",
    hi: "Hola",
    user_profile: "Perfil de usuario",
    logout: "Cerrar sesión",
    causes: "Causas",
    location_of_donations: "Ubicación de las donaciones",
    reset_funder_qualification_status: "Restablecer el estado de calificación de un financiador",
    pause_qualification: "Calificación en pausa",
    pause_qualification_process: "Pausar el proceso de calificación sin finalizar la decisión.",
    reset_funder: "Restablecer financiador",
    qualified: "Calificado",
    paused_qualification: "Calificación en pausa",
    unqualified: "No calificado",
    return_to_gs_from: "Regresar a Grant Secretary desde {{docType}}",
    referral: "¡Refiere una organización benéfica y gana tiempo adicional!",
    referralFormPopup: "Refiere a un amigo para ganar tiempo de suscripción",
    referralShareFormPopup: "Comparte tu enlace de referencia para ganar tiempo de suscripción",
    referral_code_tooltip: "Haz clic para copiar el código de referencia",
    phone_number: "Número de teléfono",
    email_address: "Correo electrónico",
    charity_name: "Nombre de la organización benéfica",
    contact_name: "Nombre de contacto",
    referral_popup_title: "Refiere a un amigo",
    logout: "Cerrar sesión",
    flagged_donor_advised: "Marcado como Fondo Asesorado por Donantes",
    DAF: "FAD",
    referral_code: "Código de referencia",
    report_grant: "Informar una subvención",
    name_of_contact: "Nombre del contacto",
    grant_amount: "Monto de la subvención",
    date_awarded: "Fecha de adjudicación",
    earn_bonus_time: "¡GANA TIEMPO EXTRA!",
    additional_information: "Información adicional",
    categories: "Categorías",
    populations_served: "Poblaciones atendidas",
    mission: "Misión",
    geographic_areas_served: "Áreas geográficas atendidas",
    org_profile: "Perfil de la Org.",
    un_sdg_goals: "Objetivos ODS de la ONU",
    social_media: "Redes sociales",
    select_goals: "Seleccionar objetivos",
    no_goals_selected: "Ningún objetivo seleccionado",
    select_social_media: "Seleccionar redes sociales",
    mission_placeholder: "¿De qué se trata su organización? Comparta brevemente aquí su propósito principal o misión fundamental.",
    emails: "Correos electrónicos",
    add_email: "Agregar correo electrónico",
    enter_new_email: "Ingresa una nueva dirección de correo electrónico",
    adding_new_email: "Agregando nuevo correo electrónico",
    target_beneficiaries: "Beneficiarios objetivo",
    measurable_outcomes: "Resultados medibles",
    type_keyword_and_press_enter: "Escriba una palabra clave y pulse Intro para añadir una etiqueta",
    tags: "Etiquetas",
    project_name_and_description: "Nombre y descripción del proyecto",
    project_date_and_cost: "Fecha y costo del proyecto",
    grant_advance_ai: "Grant Advance A.I",
    create_new_project: "Crear nuevo proyecto",
    edit_project: "Editar proyecto",
    other_information: "Otra información",
    header_and_footer_settings: "Configuración de Encabezado / Pie de página",
    exclude_header_footer: "Excluir encabezado y pie de página de la organización",
    exclude_header_footer_desc: "Cuando está marcado, el encabezado y el pie de página del perfil de la organización no se cargarán en la vista previa del documento. Esto es ideal si el encabezado y el pie de página ya están incluidos directamente en tu papel membretado o documento maestro.",
    settings_saved_successfully: "Configuración guardada correctamente",
    add_header_footer: "Esto aplicará el encabezado y pie de página que cargaste en la Configuración de tu cuenta en la parte superior e inferior de la primera página de tu documento.",
    do_not_add_header_footer: "No se aplicará encabezado ni pie de página a tu documento. Recomendamos esta opción cuando imprimes tus documentos en papelería con membrete propio.",
    account_registration: "Registro de cuenta",
    organization_info: "Información de la organización",
    billing_info: "Información de facturación",
    plan_selection: "Selección de plan",
    payment_info: "Información de pago",
    add_user_info: "Agrega tu información de usuario",
    add_organization_info: "Agrega la información de tu organización",
    add_billing_info: "Agrega tu información de facturación",
    select_plan: "Selecciona un plan para tu cuenta",
    add_payment_info: "Agrega tu información de pago",
    organization_address: "Dirección de la organización",
    address_line_2: "Línea de dirección 2",
    postal: "Código postal",
    zip: "Código ZIP",
    same_billing_address: "¿Tu dirección de facturación es la misma que la de tu organización?",
    billing_address: "Dirección de facturación",
    select_payment: "Selecciona tu método de pago",
    organization_name: "Nombre de la organización",
    province: "Provincia",
    assets: "Activos",
    revenue: "Ingresos",
    donations: "Donaciones",
    create_new_project_to_get_started: "Crea un nuevo proyecto para comenzar",
    be_sure_create_project_dg: "Asegúrate de crear un proyecto antes de usar el Generador de Documentos.",
    remove_duplicate_funders: "Eliminar financiadores duplicados",
    remove_funders_present_in_other_projects: "Eliminar financiadores de este proyecto que estén presentes en otros proyectos",
    bulk_flag_update: "Actualización masiva de banderas",
    print_return_labels: "Imprimir etiquetas de devolución",
    print_labels: "Imprimir etiquetas",
    labels: "Etiquetas",
    print_selected: "Imprimir {{text}}",
    preview_selected: "Vista previa de documentos {{text}}",
    export_all_pdf_words_selected: "Exportar todos los {{text}} (PDF, Word)",
    documents: "Documentos",
    remove_from_this_project: "Eliminar de este proyecto",
    notifications: "Notificaciones",
    feedback: "Comentarios",
    giving_history: "Historial de donaciones",
    name: "Nombre",
    director: "Director",
    custom: "Personalizado",
    international_funding: "Financiamiento internacional",
    director_name: "Nombre del director",
    from_country: "Desde el país",
    to_country: "Hacia el país",
    county: "Condado",
    sub_sector: "Subsector",
    national_giving_interest: "Interés nacional de donación",
    min_grants_to_state: "Donaciones al estado",
    min_grants_to_state_any: "Cualquier n.º de donaciones",
    years: "Años",
    filter: "Filtrar",
    geographic_filters: "Filtros geográficos",
    grant_filters: "Filtros de subvenciones",
    grant_size: "Tamaño de la subvención",
    asset_size: "Tamaño de activos",
    year_of_donation: "Año de donación",
    keywords: "Palabras clave",
    any_of_these_words: "Cualquiera de estas palabras",
    all_these_words: "Todas estas palabras",
    none_of_these_words: "Ninguna de estas palabras",
    stemming: "Derivación de palabras",
    thesaurus: "Tesauro",
    cross_reference_search: "Búsqueda de referencia cruzada",
    add_cross_reference_search: "Agregar búsqueda de referencia cruzada",
    state_filter: "Filtro por estado",
    province_filter: "Filtro por provincia",
    county_filter: "Filtro por condado",
    city_filter: "Filtro por ciudad",
    funder_characteristics: "Características del financiador",
    has_online_application: "Tiene solicitud en línea",
    does_not_have_website: "No tiene sitio web",
    does_have_website: "Tiene sitio web",
    has_submission_guidelines: "Has Submission Guidelines",
    has_phone_number: "Tiene número de teléfono",
    has_email: "Tiene correo electrónico",
    show_designated_giving: "Mostrar donaciones designadas",
    show_funders_without_donations: "Mostrar financiadores sin donaciones",
    show_more: "Mostrar más",
    search_history: "Historial de búsqueda",
    last_modified_on: "Última modificación el",
    saved_searches: "Búsquedas guardadas",
    saved_search: "Búsqueda guardada",
    saved_regional_search: "Búsqueda regional guardada",
    history: "Historial",
    created_by: "Creado por",
    choose_years: "Elegir años",
    databases: "Bases de datos",
    cross_ref_on: "Referencia cruzada activada",
    search_summary_all: "Resumen de búsqueda para todos",
    active_filters: "Filtros activos",
    group_by_funder: "Agrupar por financiador",
    grant_summary: "Resumen de subvenciones",
    median_grant: "Subvención mediana",
    average_grant: "Subvención promedio",
    view_saved_search: "Ver búsqueda guardada",
    manage_coupons: "Administrar cupones",
    create_new_coupon: "Crear nuevo cupón",
    recipient_name: "Historial de donaciones",
    grant_purpose: "Propósito de subvención",
    search_by_recipient_name: "Buscar por nombre del beneficiario",
    search_by_grant_purpose: "Buscar por propósito de la subvención",
    search_by_funder_name: "Buscar por nombre del financiador",
    type: "Tipo",
    discount: "Descuento",
    tax: "Impuesto",
    extra_time: "Tiempo extra",
    expires_on: "Vence el",
    email_login: "Correo de acceso",
    reenter_password: "Reingresar contraseña",
    no_plan_selected: "Ningún plan seleccionado",
    subscription_summary: "Resumen de suscripción",
    business_number: "Número comercial",
    title: "Título",
    createdDate: "Fecha de creación",
    createdBy: "Creado por",
    notified: "Notificado",
    notification: "Notificación",
    emailNotificationDate: "Fecha de notificación por correo",
    editNote: "Editar nota",
    removeNote: "Eliminar nota",
    editAlert: "Editar alerta",
    removeAlert: "Eliminar alerta",
    updateAlert: "Actualizar alerta",
    enterTitle: "Ingrese título",
    selectEmail: "Seleccionar correo electrónico",
    notes_by: "Notas de",
    selectStatusFlag: "Seleccionar estado de bandera",
    documentType: "Tipo de documento",
    flagStatus: "Estado de bandera",
    submissionMethod: "Método de envío",
    flagDate: "Fecha de bandera",
    remove: "Eliminar",
    funderStatus: "Estado del financiador",
    create_project: "Crear proyecto",
    remove_project: "Eliminar proyecto",
    unarchive: "Desarchivar",
    archive_project: "Archivar proyecto",
    mark_project_as_completed: "Marcar proyecto como completado",
    activate_project: "Activar proyecto",
    activate_project_button: "Activar proyecto",
    no_projects_yet_heading: "Aún no tienes proyectos",
    search_manually: "Buscar manualmente",
    start_qualifying_funders: "Comenzar a calificar",
    continue_qualifying_funders: "Continuar calificando",
    view_funders: "Ver financiadores",
    add_funders_to_project: "Agregar financiadores a este proyecto",
    keep_looking_for_funders: "Seguir buscando financiadores",
    use_your_peer_network: "Usa tu red de organizaciones similares",
    peer_search: "Búsqueda entre pares",
    run_peer_search: "Ejecutar búsqueda entre pares",
    about_qualifying_funders: "Acerca de calificar financiadores",
    about_peer_search: "Acerca de la búsqueda entre pares",
    project_overview_title: "Resumen de {{name}}",
    project_name: "Nombre del proyecto",
    shared_by: "Compartido por",
    project_status: "Estado del proyecto",
    notified_at: "Notificado el",
    notify_at: "Notificar el",
    updating_notes: "Actualizando notas",
    attached_documents: "Documentos adjuntos",
    alert_notification: "Notificación de alerta",
    notification_sent: "Notificación enviada",
    notification_by_email: "Notificación por correo electrónico",
    attach_documents: "Adjuntar documentos",
    loading_attached_documents: "Cargando documentos adjuntos",
    search_by_year_searchbar_title: "Por año de fundación",
    search_by_name_searchbar_title: "Por nombre del financiador",
    search_by_director_searchbar_title: "Por la junta directiva",
    search_by_custom_searchbar_title: "Por contactos privados",
    search_by_keyword_searchbar_title: "Al dar interés",
    create_coupon: "Crear cupón",
    update_coupon: "Actualizar cupón",
    code: "Código",
    expiration_date: "Fecha de vencimiento",
    toggle_to_extra_time: "Cambiar a tiempo extra",
    toggle_to_discount: "Cambiar a descuento",
    extra_month: "Mes extra",
    discount_percentage: "Porcentaje de descuento",
    coupon_default_flag: "Bandera predeterminada del cupón",
    unlock_plans: "Desbloquear planes",
    template_coupon: "Plantillas de cupones",
    search_by_giving_history_searchbar_title: "By Giving History",
    demo_access_link: "Enlace de acceso a la demo",
    signed_in_as: "Conectado como",
    for_sales_use_only: "Solo para uso interno",
    your_access_link: "Tu enlace de acceso",
    expires_in: "Expira en",
    link_becomes_invalid: "el enlace deja de ser válido después de eso",
    email_reminders: "Recordatorios por correo electrónico",
    file_attachments: "Archivos adjuntos",
    add_notification: "Agregar notificación",
    add_email_notification: "Agregar notificación por correo electrónico",
    edit_email_notification: "Editar notificación por correo electrónico",
    select_date: "Seleccionar fecha",
    notifications_found: "Notificaciones encontradas",
    switch_to_new: "Cambiar a la nueva versión",
    switch_to_legacy: "Cambiar a la versión anterior",
    has_application_description: "Tiene descripción de la solicitud",
    giving_interest: "Interés de donación",
    board_directors: "Miembros de la junta directiva",
    year_founded: "Año de fundación",
    private_contacts: "Contactos privados",
    welcome_back_2: "Bienvenido de nuevo",
    email_address_2: "Correo electrónico",
    recently_saved_search: "Búsqueda guardada recientemente",
    edit_notification: "Editar notificación",
    licenses: "Licencias",
    registered: "Registrado",
    status: "Estado",
    role: "Rol",
    delete: "Eliminar",
    suspend_license: "Suspender licencia",
    licenses_used: "licencias utilizadas",
    available: "Disponible",
    new_main_user: "Nuevo usuario principal",
    previous_main_user: "Usuario principal anterior",
    will_be_downgraded_part: "será degradado a un subusuario con el",
    supervisor: "Supervisor",
    main_user: "Usuario principal",
    not_applied: "No aplicado",
    disabled: "Deshabilitado",
    active: "Activo",
    expired: "Expirado",
    deleted: "Eliminado",
    trial: "Prueba",
    trial_expired: "Prueba expirada",
    upgrade_demo_account: "Actualizar cuenta demo",
    account_email: "Correo electrónico de la cuenta",
    pipedrive: "Pipedrive",
    number_of_licenses: "Número de licencias",
    payment: "Pago",
    pay_now: "Pagar ahora",
    paid: "Pagado",
    payment_method: "Método de pago",
    send_payment_link: "Enviar enlace de pago",
    skip_payment: "Omitir pago",
    search_by: "Buscar por",
    no_data_to_display: "No hay datos para mostrar",
    qualified_funder: "Financiador calificado",
    qualifications: "Calificaciones",
    grant_type: "Tipo de subvención",
    qualified_by: "Calificado por",
    date_added: "Fecha de agregado",
    internal_notes: "Notas internas",
    funder_qualification: "Calificación del financiador",
    edit_funder_qualification: "Editar calificación del financiador",
    qualify_funders: "Calificar financiador(es)",
    create_add_to_favorite_list: "Crear/Agregar a la lista de favoritos",
    enter_rationale_or_notes: "Ingresa la justificación o notas",
    delete_qualification: "Eliminar calificación",
    type_a_sector_name: "Escribe un nombre de sector",
    this_field_is_empty: "El campo está vacío",
    adding_sector: "Agregando sector",
    adding_grant_type: "Agregando tipo de subvención",
    choose_grant_type_or_create_one: "Elige un tipo de subvención o crea uno",
    other_funding_source: "Otra fuente de financiamiento",
    statistical_proof: "Prueba estadística",
    do_it_with_grant_advance_ai: "Hazlo con Grant Advance AI",
    find_matching_funders: "Encontrar financiadores compatibles",
    find_funders_with_ai: "Buscar financiadores con IA",
    ai_beta_badge_label: "Acerca del estado beta de la IA",
    draft_your_letter_of_inquiry: "Redactar tu carta de consulta",
    write_loi_with_ai: "Escribir la LOI con IA",
    generate_full_content: "Generar todo el contenido",
    generate_step_content: "Generar con IA",
    regenerate_step_content: "Regenerar con IA",
    reviewed: "Revisado",
    mark_as_reviewed: "Marcar como revisado",
    change_tone: "Cambiar tono",
    change_content_tone: "Cambiar tono del contenido",
    save_and_work_on_later: "Guardar y continuar después",
    generate_full_content_with_ai: "Generar todo el contenido con IA",
    select_tone: "Seleccionar tono",
    select_reason: "Seleccionar motivo",
    reason_donation: "Gracias por su donación",
    reason_rejected: "Gracias por considerarlo (Rechazado)",
    reason_no_reply: "Gracias por considerarlo (Sin respuesta)",
    reason_other: "Otro",
    other_reason_placeholder: "Describa el motivo de esta carta",
    generate: "Generar",
    overwrite_content: "Sobrescribir contenido",
    entire_country: "Todo el país",
    everywhere_within_one_country: "En todo un país",
    specific_area: "Área específica",
    a_region_a_city_or_both: "Una {{orgRegion}}, una ciudad o ambas",
    select_a_country: "Selecciona un país",
    all_states: "Todos los estados",
    all_provinces: "Todas las provincias",
    all_cities: "Todas las ciudades",
    all_counties: "Todos los condados",
    add_area: "Agregar área",
    add_charity: "Agregar organización benéfica",
    add_statistical_proof: "Agregar prueba estadística",
    search_more_suggestions: "Buscar más sugerencias",
    add_your_own_statistical_proof: "Agregar tu propia prueba estadística",
    statistical_proofs_added: "Pruebas estadísticas agregadas",
    view_source: "Ver fuente",
    areas_added: "Áreas agregadas",
    go_to_fields: "Ir a los campos",
    add_stat: "Agregar estadística",
    generate_suggestions: "Generar sugerencias",
    on: "Activado",
    off: "Desactivado",
    quick_qualification: "Calificación rápida",
    already_qualified: "Ya calificado",
    qualifying_preferences_uppercase: "PREFERENCIAS DE CALIFICACIÓN",
    carry_forward_selection: "Mantener selección",
    keeps_your_project_picks_selected: "Mantiene las selecciones de tu proyecto para el próximo financiador",
    auto_advance_next_funder: "Avanzar automáticamente al siguiente financiador",
    not_fit: "No apto",
    add_to_project: "Agregar al proyecto",
    qualify_funder: "Calificar financiador",
    add_details: "Agregar detalles",
    add_details_helper_collapsed: "Sector, tipo de subvención, notas — opcional",
    add_details_helper_expanded: "Opcional",
    pick_a_verdict_to_continue: "Elige un veredicto para continuar",
    marked_qualified: "Marcado como calificado",
    marked_not_fit: "Marcado como no apto",
    select_funder: "Seleccionar financiador",
    previous_funder: "Financiador anterior",
    next_funder: "Siguiente financiador",
    reopen_quick_qualification: "Reabrir calificación rápida",
    qualification_verdict: "Veredicto de calificación",
    funder_revoked: "Financiador revocado",
    new_donees: "Nuevos beneficiarios",
    already_applied: "Ya solicitó",
    view_projects: "Ver proyectos",
    do_not_contact: "No contactar",
    funded: "Financiado",
    previously_declined: "Rechazado anteriormente",
    returned_to_sender: "Devuelto al remitente",
    added_to_a_project: "Agregado a un proyecto",
    added_on_date: "Agregado {{date}}",
    flag_status_added: "Agregado",
    flag_status_submitted: "Enviado",
    flag_status_approved: "Aprobado",
    flag_status_declined: "Rechazado",
    flag_status_no_response: "Sin respuesta",
    flag_status_awarded: "Otorgado",
    flag_status_proposal_requested: "Propuesta solicitada",
    flag_status_declined_do_not_contact: "No contactar",
    flag_status_inquiry_submitted: "Consulta enviada",
    flag_status_proposal_submitted: "Propuesta enviada",
    flag_status_thankyou_submitted: "Agradecimiento enviado",
    flag_status_impact_report_submitted: "Informe de impacto enviado",
    flag_status_custom_letter_submitted: "Carta personalizada enviada",
    flag_status_inquiry_declined: "Consulta rechazada",
    flag_status_proposal_declined: "Propuesta rechazada",
    flag_status_return_to_sender: "Devuelto al remitente",
    coupon_code: "Coupon Code",
    sector_subsector: "Sector / Subsector",
    start_day: "Día de inicio",
    save_options: "Guardar opciones",
    province_plus_one: "Provincia+",
    province_plus_other: "Provincias+",
    state_plus_one: "Estado+",
    state_plus_other: "Estados+",
    funders_matched: "Financiadores coincidentes",
    directors_matched: "Directivos coincidentes",
    total_directors: "Total de directivos",
    change_ownership: "Cambiar propietario",
    current_owner: "Propietario actual",
    created: "Creado",
    last_login: "Último acceso",
    new_owner: "Nuevo propietario",
    sales_account: "Cuenta de ventas",
    confirm_changes: "Confirmar cambios",
    roles: "Rol(es)",
    created_by: "Creado por",
    account_information: "Información de la cuenta",
    transfer_ownership: "Transferir propiedad",
    delete_account_exclamation: "¿Eliminar cuenta?",
    delete_account: "Eliminar cuenta",
    reset_fields: "Restablecer campos",
    map_now: "Asignar ahora",
  },
  crossReference: {
    any_of_these_words: "Cualquiera de estas palabras",
  },
  filters: {
    no_low_limit: "Sin límite inferior",
    no_upper_limit: "Sin límite superior",
  },
  errors: {
    model_error: "Compruebe si hay errores y vuelva a intentarlo",
    general_error: "Ha ocurrido un error",
    profile_still_loading: "Su perfil todavía se está cargando. Espere un momento y vuelva a intentarlo.",
    invalid_token: "Token inválido",
    confirming_account_error: "Este enlace ha expirado. ¿Quieres que te enviemos un nuevo correo electrónico de activación?",
    invalid_image: "Imagen inválida",
    inform_crop_area: "Ajuste la imagen para adaptarse a las dimensiones requeridas",
    funder_not_found: "Financiador no encontrado",
    file_list_error: "Error en la lista de archivos",
    select_at_least_one_funder: "Por favor, seleccione al menos un financiador antes de continuar",
    select_one_or_more_funders_delete: "Seleccione uno o más financiadores para eliminar",
    select_one_or_more_funders_block: "Seleccione uno o más financiadores para bloquear",
    this_link_has_expired: "Este enlace ha expirado.",
    would_you_like_us_to_send_email: "¿Desea que le enviemos un nuevo correo electrónico de activación/configuración?",
    recaptcha_failed: "La verificación de seguridad falló. Inténtelo nuevamente haciendo clic en Siguiente.",
    recaptcha_required: "Se requiere verificación de seguridad.",
    both_password_must_be_the_same: "Ambas contraseñas deben ser iguales",
    error_creating_token: "Error al crear el token",
    select_new_owner: "Seleccionar el nuevo propietario"
  },
  success: {
    logout_success: "Cierre de sesión de usuario con éxito",
    copied_to_cliboard: "Copiado al portapapeles",
    organization_update: "La información de la organización se actualizó correctamente",
  },
  messages: {
    jumpstart_journey: "Estimado/a {userName}, inicie su viaje con estas diapositivas informativas para navegar por nuestro sitio, encontrar posibles financiadores y redactar solicitudes de subvenciones.",
    have_questions: "¿Tiene preguntas? Únase a nuestro seminario web interactivo para obtener soporte en tiempo real. Reserve su lugar haciendo clic en el enlace aquí.",
    follow_guide: "Siga la guía adjunta para obtener estrategias probadas para asegurar la financiación de subvenciones.",
    referral_bonus_1: "Cuando la primera organización que refiera se registre en Grant Advance, recibirá un mes adicional de bonificación.",
    referral_bonus_2: "La segunda referencia le otorga dos meses adicionales.",
    referral_bonus_3: "La tercera y cada referencia adicional le otorgan tres meses adicionales cada una.",
    report_grant_bonus_1: "Licencias de usuario adicionales para su equipo",
    report_grant_bonus_2: "Servicios de redacción de cartas de consulta",
    report_grant_bonus_3: "Suscripciones y renovaciones de membresía",
    it_takes_less_than_a_minute: "Solo te llevará un minuto y tus créditos estarán listos. Los créditos no tienen valor en efectivo y no se pueden combinar con otras ofertas.",
    password_recovery_message: "Para recibir una nueva contraseña, introduzca el nombre de usuario y la dirección de correo electrónico que utilizó para registrarse",
    inform_new_password_message: "Por favor, introduzca su nueva contraseña",
    setting_up_account_message: "Para activar su cuenta, introduzca la contraseña y confírmela",
    confirming_account_wait: "Por favor, espere mientras confirmamos su cuenta",
    first_letterhead_message: "- El membrete debe tener aproximadamente 700 x 200 px.",
    second_letterhead_message: "- Los formatos compatibles son .GIF, .png, .jpeg y .jpg.",
    third_letterhead_message: "- El membrete de su organización aparecerá en la parte superior de todos los documentos.",
    check_organization_settings_message: "Por favor, compruebe la configuración del membrete del perfil de su organización o póngase en contacto con el soporte técnico.",
    funders_not_selected_message: "Por favor, seleccione al menos un financiador antes de continuar",
    project_not_selected_message: "Por favor, cree o seleccione un proyecto primero",
    you_must_select_state: "Debe seleccionar un estado para habilitar el filtro de ciudad.",
    deselect_all_counties: "Deseleccione todos los condados para habilitar el filtro de ciudad.",
    select_one_favorite_list: "Seleccione al menos una lista de favoritos o cree una nueva",
    create_new_favorite_list: "Crear nueva lista de favoritos",
    add_funders_favorite_list: "Añadir financiador(es) a favoritos",
    saved_search_load_successfully: "Búsqueda guardada cargada correctamente",
    save_search: "Guardar búsqueda",
    delete_project: "¿Está seguro de que desea eliminar este proyecto?",
    are_you_sure: "¿Está seguro?",
    this_action_will_remove_document_funder: "Esta acción eliminará el documento para este financiador",
    this_action_will_remove_master_document: "Esta acción eliminará este documento maestro",
    want_to_remove_the_funder: "¿Desea eliminar el financiador de esta lista?",
    this_will_remove_customized_documents: "Esto eliminará {{documents}} documento(s) personalizado(s) y devolverá el financiador a la lista maestra. Para eliminar financiador(es) permanentemente, elimínelos de la lista maestra.",
    remove_the_funders_from_the_projects: "Elimina los financiadores de los proyectos que seleccionó del proyecto actual.",
    select_in_dropdown_example: "Ej.: Si selecciona un proyecto en el desplegable y tiene 3 financiadores, 'a', 'b' y 'c' y el proyecto en el que está trabajando también tiene 'a', 'b', 'c', estos serán eliminados del proyecto en curso.",
    this_will_remove_funders_from_this_project: "Esta acción eliminará {{funders}} financiador(es) de este proyecto.",
    want_reset_this_funder: "¿Estás seguro de que quieres restablecer este financiador?",
    do_not_insert_pre_loaded_letterhead_or_footer_document: "No inserte membrete o pie de página precargados desde el perfil de su organización en los documentos generados",
    new_email_has_been_send: "Se ha enviado un nuevo correo electrónico a tu dirección.",
    stop_working_with_fragmented_views: "Deja de trabajar con vistas fragmentadas.",
    gain_unified_donor_intelligence: "Obtén una visión unificada de los donantes y crea propuestas que realmente impacten.",
    unlock_full_access_become_a_member: "Desbloquea el acceso completo: Hazte miembro.",
    see_how_it_works_schedule_a_free_tour: "Descubre cómo funciona: Programa una visita gratuita.",
    just_a_reminder: "Solo un recordatorio: Su",
    discount_will_expire: "descuento vencerá el",
    un_sdg_goals: "¿Generando impacto? Los ODS de la ONU son objetivos globales para un futuro mejor (como 'Hambre Cero' o 'Acción por el Clima').",
    social_media: "¿Tienes redes sociales? ¡Agrega los enlaces a tus perfiles (como Instagram, Facebook, X, LinkedIn) aquí mismo!",
    categories: "Seleccione las categorías que mejor describan la misión o las áreas de enfoque de su organización.",
    geographic_areas_served: "Especifique las regiones geográficas donde su organización brinda servicios o apoyo.",
    populations_served: "Indique los principales grupos o comunidades a los que sirve su organización.",
    mission: "¿De qué se trata su organización? Comparta brevemente aquí su propósito principal o misión fundamental.",
    be_sure_creating_project_before_using_search_engine: "Asegúrate de crear el proyecto antes de usar el motor de búsqueda.",
    assets_tooltip: "Activos totales reportados al final del año, según lo indicado en la serie de formularios 990 del IRS",
    revenue_tooltip: "Ingresos anuales totales registrados en la serie de formularios 990 del IRS",
    donations_tooltip: "Contribuciones totales realizadas durante el año, basadas en la serie de formularios 990 del IRS",
    charities_helping_charities: "Programa de Referencias: Organizaciones ayudando a Organizaciones",
    refer_charity_earn_bonus: "¡Refiere una organización y gana tiempo adicional!",
    refer_charity_line1: "Cuando la primera organización que refieras se registre en Grant Advance, recibirás un mes adicional de bono.",
    refer_charity_line2: "La segunda referencia te otorga dos meses adicionales.",
    refer_charity_line3: "La tercera y cada referencia adicional te otorgan tres meses adicionales cada una.",
    heads_up_irs_check_profile: "¡Atención! El IRS no proporciona archivos adjuntos en los datos electrónicos que usamos aquí. Pero a veces, los encontrará en la versión PDF de la declaración. ¡Consulte el perfil!",
    heads_up_irs_check_below: "¡Atención! El IRS no proporciona archivos adjuntos en los datos electrónicos que usamos aquí. Sin embargo, a veces, encontrará dichos archivos adjuntos en la versión PDF de la declaración. ¡Consulte a continuación!",
    remove_from_this_project: "Elimina los financiadores seleccionados del proyecto actual si ya existen en los proyectos elegidos, ayudando a evitar duplicados.",
    delete_selected_custom_document: "Esta acción eliminará el documento personalizado para los financiadores seleccionados.",
    delete_single_custom_document: "Esta acción eliminará el documento personalizado para este financiador.",
    recaptcha_loading: "Espere mientras se carga la verificación de seguridad...",
    consent_to_allowing: "Doy mi consentimiento para que Grant Advance comparta esta buena noticia en su sitio web, sus redes sociales y otras plataformas",
    type_keyword: "Escribe una palabra clave y presiona Enter para agregar una etiqueta",
    add_alternatives_to_root_word: "Agregar alternativas a la(s) palabra(s) raíz en tu búsqueda",
    view_and_manage_searches: "Ver y administrar tus resultados de búsqueda guardados y la información de filtros seleccionados para futuras consultas",
    load_saved_search: "Cargar búsqueda guardada",
    load_saved_search_description: "Al cargar la búsqueda guardada, se restablecerán los resultados de búsqueda actuales y la información de filtros a la búsqueda guardada que seleccionaste.",
    switch_search_type: "Cambiar tipo de búsqueda",
    switch_search_type_description: "Cambiar el tipo de búsqueda eliminará los filtros que aplicaste aquí. ¿Deseas continuar?",
    no_saved_search: "No hay búsquedas guardadas",
    coupon_textfield_placeholder: "Buscar por código de cupón, nombre o creador",
    no_results_found: "No se encontraron resultados",
    no_results_found_2: "No se encontraron resultados, intenta con otra palabra clave.",
    go_to_search_page: "Ir a la página de búsqueda",
    searching_for_funders: "Buscando financiadores",
    kindly_ensure_template_personalized: "Asegúrese de personalizar la plantilla para que refleje su propia voz y mensaje. No recomendamos copiar y pegar la carta directamente. Dado que es accesible para todos nuestros miembros, es mejor usarla como inspiración para crear su propia versión única.",
    i_understand_deleting_this_master: "Entiendo que eliminar este documento maestro eliminará permanentemente",
    customized_documents: "documentos personalizados",
    action_cannot_be_undone: "y esta acción no se puede deshacer",
    select_notification_date: "Selecciona la fecha en la que deseas ser notificado",
    delete_this_alert: "¿Te gustaría eliminar esta alerta?",
    delete_this_note: "¿Te gustaría eliminar esta nota?",
    update_funders_flag_status: "Esta acción actualizará el estado de bandera del financiador",
    set_project_as_completed: "¿Marcar el proyecto {{projectName}} como completado?",
    activate_project_confirm: "¿Activar '{{projectName}}'? Esto lo marcará como activo y moverá el proyecto activo actual de nuevo a En Progreso.",
    no_similar_charities_title: "Agregue Organizaciones Similares Primero",
    no_similar_charities_confirm: "Este proyecto todavía no tiene organizaciones similares. Agregue algunas para ejecutar una Búsqueda de Pares.",
    no_projects_yet_description: "Crea un proyecto para comenzar a encontrar financiadores y generar documentos de subvención.",
    no_funders_in_project: "No hay financiadores en tu Proyecto",
    funders_currently_in_project_singular: "{{count}} financiador actualmente en tu Proyecto",
    funders_currently_in_project_plural: "{{count}} financiadores actualmente en tu Proyecto",
    qualified_funders_progress: "{{qualifiedCount}} de {{fundersAmount}} calificados",    peer_search_info: "Esto utilizará la lista de organizaciones benéficas similares para buscar financiadores que las hayan apoyado.",
    qualifying_info: "Calificar es donde revisas a cada financiador de este proyecto y determinas si es realmente adecuado — elegibilidad, prioridades de donación y plazos — antes de escribirle.",
    created_on_date: "Creado el: {{createdAt}}",
    ai_draft_recommended: "La IA puede generar un buen primer borrador de este documento para que lo revises y personalices.",
    ai_beta_badge_tooltip: "Esta función de IA está en fase beta. Los resultados pueden ser incompletos o inexactos, así que revísalos antes de confiar en ellos.",
    manual_draft_recommended: "Este documento es mejor escribirlo manualmente.",
    status_flag_for: "Estado de bandera para {{foundationName}}",
    upload_document: "Sube cualquier tipo de documento de hasta {{fileSize}} MB",
    upload_document_up_to: "Sube hasta {{fileCount}} archivos a la vez, con un tamaño máximo de {{fileSize}} MB cada uno. Tipos de archivo compatibles: Todos los archivos",
    this_action_will_delete: "Esta acción eliminará {{name}}",
    your_session_has_expired: "Tu sesión ha caducado. Vuelve a iniciar sesión.",
    your_account_without_permission: "Tu cuenta no tiene los permisos necesarios para realizar esta acción.",
    congratulations_on_securing_funding: "¡Enhorabuena por haber conseguido financiación! Ahora, saca el máximo provecho de este éxito. Informa sobre tus subvenciones y recibe 25 créditos de bonificación (con un valor de 25 $) por cada una, canjeables por servicios que ayuden a tu organización a lograr aún más:",
    select_one_or_more_subscription_plans: "Selecciona uno o más planes de suscripción",
    action_50percent_discount: "Esta acción dará a este cupón un descuento mayor al 50%",
    token_copied_to_clipboard: "Token copiado al portapapeles",
    open_this_link_in_a_separated_browser: "Abre este enlace en un navegador separado o en una ventana de incógnito para recorrer la plataforma con esta cuenta de demostración. Úsalo durante llamadas con prospectos para mostrar las funciones sin necesidad de una contraseña.",
    do_not_share_with_customers: "No compartir con clientes· Abrir en un navegador separado o en una ventana de incógnito",
    resend_funder_alert_notifications: "Reenviar notificaciones de alerta al financiador",
    notifications_send_sucessfully: "{{count}} notificación(es) enviada(s) correctamente",
    enter_your_account_details: "Ingresa los datos de tu cuenta para iniciar sesión",
    having_trouble_signing_in: "¿Tienes problemas para iniciar sesión?",
    you_can_reset_password_here: "Puedes restablecer tu contraseña aquí",
    kindly_enter_email_address: "Ingresa la dirección de correo electrónico que utilizaste para registrarte. Te enviaremos un enlace para restablecer tu contraseña.",
    kindly_enter_new_password: "Ingresa tu nueva contraseña",
    password_must_contain: "La contraseña debe contener",
    password_length_requirement: "Al menos 8 caracteres",
    password_uppercase_requirement: "Al menos una letra mayúscula (A–Z)",
    password_lowercase_requirement: "Al menos una letra minúscula (a–z)",
    password_number_requirement: "Al menos un número (0–9)",
    password_special_character_requirement: "Al menos un carácter especial (!@#$%^&* etc.)",
    notifications_send_sucessfully: "{{count}} notificación(es) enviada(s) correctamente",
    the_user_will_lose_access: "El usuario perderá el acceso hasta que la licencia sea activada",
    suspend_the_license: "¿Suspender esta licencia?",
    user_will_remain_active: "El acceso del usuario permanecerá activo durante la activación de la licencia",
    active_the_license: "¿Activar esta licencia?",
    activate_license: "Activar licencia",
    change_to_main_user: "Cambiar a usuario principal",
    remove_this_license: "¿Eliminar esta licencia?",
    you_are_about_to_remove_this_license: "Está a punto de eliminar esta licencia",
    change_the_main_user: "¿Cambiar el usuario principal?",
    this_updates_the_organization_master_account: "Esto actualiza la cuenta maestra de la organización. La acción se aplica inmediatamente.",
    remove_email_notification: "Eliminar notificación por correo electrónico",
    are_you_sure_remove_alert: "¿Seguro que deseas eliminar esta notificación por correo electrónico?",
    opens_bambora_form: "Abre el formulario de Bambora - actualizar tras la aprobación",
    mark_as_paid: "Marcar como pagado - actualizar directamente",
    to_be_implemented: "Por implementar",
    upgrade_with_no_payment: "Actualizar sin pago",
    on_confirm_demo_data_message: "Al confirmar: los datos de demostración se conservan, el estado se restablece (vuelve a aparecer el diálogo de bienvenida) y se envía el correo de configuración.",
    delete_this_qualification: "¿Seguro que deseas eliminar esta calificación?",
    funder_qualified_successfully: "Financiador calificado correctamente",
    last_qualified_for: "Última calificación para",
    press_enter_enter_to_add_grant_type: "Presiona Enter para agregar un tipo de subvención",
    find_or_create_grant_type: "Buscar o crear tipo de subvención",
    press_enter_to_add_sector: "Presiona Enter para agregar un sector",
    find_or_create_sector: "Buscar o crear sector",
    select_at_least_one_sector: "Selecciona al menos un sector",
    select_at_least_one_grant_type: "Selecciona al menos un tipo de subvención",
    ai_scan_database: "La IA analiza la base de datos y clasifica a los financiadores según su compatibilidad con el proyecto.",
    peer_search_no_ai: "Busca financiadores a través de organizaciones similares a la tuya — sin IA.",
    generate_full_loi: "Genera una carta de consulta completa a partir de los detalles de tu proyecto en aproximadamente un minuto.",
    grant_advance_ai_benefit: "Esta información alimenta a Grant Advance AI, que la utiliza para generar documentos como cartas de consulta y propuestas, y para encontrar financiadores que coincidan con los objetivos de tu proyecto.",
    grant_advance_ai_active: "Grant Advance AI utiliza esta información para generar documentos como cartas de consulta y propuestas, y para encontrar financiadores que coincidan con los objetivos de tu proyecto.",
    required_fields_legend: "* Campos obligatorios",
    fill_in_name_and_description: "Completa el Nombre del proyecto y la Descripción arriba y luego genera sugerencias de IA.",
    ready_to_generate_ai_suggestions: "Listo para generar sugerencias de IA para Beneficiarios objetivo, Palabras clave y Prueba estadística según los detalles de tu proyecto.",
    statistical_proof_recommendation: "Recomendamos agregar hasta 2 pruebas estadísticas, pero puedes agregar tantas como quieras.",
    no_statistical_proof_suggestions: "Aún no hay sugerencias disponibles. Intenta buscar más.",
    some_steps_not_reviewed: "No has revisado el contenido generado por IA en los siguientes pasos de tu carta de consulta.",
    some_steps_not_completed: "Parece que algunos pasos de este módulo aún no están completos. Continúa solo si deseas omitirlos.",
    review_with_ai_powered: "¿Quieres revisar y personalizar este documento con IA?",
    ai_generated_content_please_review: "Contenido generado por IA: revísalo, edítalo si es necesario y confírmalo.",
    overwrite_content_warning: "Al activarlo, el contenido generado reemplazará todos los pasos existentes. Al desactivarlo, solo se generará contenido para los pasos vacíos.",
    gas_description: "Agrega los lugares donde trabaja tu organización. Elige un país completo o una {{orgRegion}} o ciudad dentro de {{orgCountry}}.",
    specific_area_description: "Las áreas se muestran para {{orgCountry}}. Para atender otro país, agrégalo como país completo.",
    saved_search_loaded_main: "Búsqueda guardada cargada y aplicada",
    saved_search_loaded_result: "Búsqueda guardada cargada y aplicada",
    are_you_sure_you_want_proceed: "¿Seguro que deseas continuar?",
    review_with_ai: "Revisar con IA",
    to_create_personalize_ai_doc: "Para crear un documento de IA más personalizado, Grant Advance recomienda completar todos los pasos de tu {{docType}}.",
    funder_inactive: "Financiador inactivo durante 3+ años. No se ha reportado actividad ante el IRS.",
    this_funder_has_supported: "Este financiador ha apoyado a {{count}} nuevos beneficiarios en los últimos 3 años.",
    you_have_an_existing_application: "Tienes una solicitud activa con este financiador.",
    funder_asked_not_to_be_contacted: "Este financiador pidió no ser contactado de nuevo.",
    you_have_received_funding: "Has recibido financiamiento de este financiador.",
    past_application_was_declined: "Una solicitud anterior a este financiador fue rechazada.",
    mail_was_returned_to_sender: "El correo enviado a este financiador fue devuelto. Verifica la dirección antes de volver a solicitar.",
    funder_already_in_a_project: "Este financiador ya está en un proyecto de tu organización.",
    ownership_will_be_transferred: "La propiedad se transferirá inmediatamente a la cuenta de ventas seleccionada.",
    change_the_owner_of_this_demo: "Cambiar el propietario de esta cuenta demo",
    this_account_was_removed: "Esta cuenta fue eliminada.",
    the_selected_sales_associate_will_become_the_new_owner: "El representante de ventas seleccionado se convertirá en el nuevo propietario de esta cuenta demo. Las asignaciones de propiedad actuales se actualizarán inmediatamente después de la confirmación.",
    are_you_sure_delete_demo_account: "¿Está seguro de que desea eliminar esta cuenta de demostración? Esta acción no se puede deshacer. Todos los datos, la configuración y el historial asociados se eliminarán de forma permanente y ya no estarán accesibles.",
    geographic_areas_confirm_title: "¿Agregar las áreas seleccionadas antes de continuar?",
    geographic_areas_confirm_description: "Tus selecciones aún no se han agregado. «Agregar y continuar» las agrega sin volver al botón Agregar área. También puedes continuar sin agregarlas.",
    geographic_areas_add_failed: "No pudimos agregar las áreas seleccionadas. Revisa tus selecciones e inténtalo de nuevo.",
    geographic_areas_save_failed: "No pudimos guardar tus áreas. Inténtalo de nuevo.",
    unadded_geographic_areas: "Tienes áreas sin agregar",
    unadded_geographic_areas_description: "Las áreas seleccionadas aún no están en tu lista. Vuelve y haz clic en Agregar área para conservarlas, o continúa sin ellas.",
    click_here_to_create_sector: "Haga clic aquí para crear un nuevo sector",
    click_here_to_create_grant_type: "Haga clic aquí para crear un nuevo tipo de subvención",
    fields_mapped: "{{amount}} de {{total}} campos asignados",
    require_fixing: "{{amount}} de {{total}} campos por corregir",
    fields_can_be_mapped: "Algunos encabezados son similares a tus campos. ¿Asignarlos automáticamente?",
    delete_information: "Eliminar información de {{name}}",
    remove_information: "¿Eliminar esta información de {{name}}?",
    importAnOrganizationDatabase: "Importar una base de datos de organizaciones",
    importAnIndividualDatabase: "Importar una base de datos de personas",
    importOrganizationHelp: "Importa organizaciones con datos de contacto y ubicaciones.",
    importIndividualHelp: "Importa personas con datos de contacto y cargos.",
  },
  user_menu: {
    profile: "Perfil",
    logout: "Cerrar sesión",
  },
  prompt: {
    areYouSure: "¿Estás seguro?",
    confirmRemove: "Confirmar eliminación",
  },
  side_menu: {
    administration: "Administración",
    manage_account: "Administrar cuenta",
    manage_announcement: "Anuncios",
    manage_subscription_plan: "Plan de suscripción",
    manage_coupons: "Cupones",
    manage_feedbacks: "Comentarios",
    manage_deadlines: "Plazos",
    manage_smart_phrases: "Frases inteligentes",
    manage_foundations: "Administrar fundaciones",
    manage_plans: "Administrar planes",
    account: "Cuenta",
    user_profile: "Perfil del usuario",
    additional_users: "Usuarios adicionales",
    organization_profile: "Perfil de la organización",
    project_manager: "Gerente de proyecto",
    project_list: "Proyectos",
    project_archive: "Proyectos archivados",
    search_engine: "Buscador",
    search_engine_canada: "Buscador - CA (beta)",
    by_giving_history: "Por historial de donaciones",
    by_name: "Por nombre del financiador",
    by_director: "Por la junta directiva",
    by_year: "Por año de fundación",
    by_deadline: "Por fecha límite",
    by_rating: "Por calificación",
    by_custom: "Por contactos privados",
    by_custom_profile: "Por perfil personalizado (Nuevo)",
    document_generator: "Generador de documentos",
    inquiry: "Consulta",
    proposal: "Propuesta",
    budget: "Presupuesto",
    custom_letter: "Carta personalizada",
    grant_secretary: "Secretaría de subvenciones - Imprimir",
    manage_funders: "Administrar financiadores",
    favorites: "Favoritos",
    blocked_funders: "Bloqueados",
    custom_databases: "Bases de datos personalizadas",
    by_keyword: "Al dar interés",
    by_international_funding: "Financiación internacional (PRO)",
    thank_you: "Agradecimiento",
    impact_report: "Informe de impacto",
    previous: "Anterior",
    by_recipient_name: "Por nombre del beneficiario",
    by_grant_purpose: "Por propósito de la subvención",
    by_funder_name: "Por nombre del financiador",
  },
  buttons: {
    done: "Listo",
    create_account: "Crear cuenta",
    send: "Enviar",
    reset_password: "Restablecer contraseña",
    add_user: "Agregar usuario",
    insert_user: "Insertar usuario",
    save_changes: "Guardar cambios",
    update_profile: "Actualizar perfil",
    add_to_favorites: "Agregar a favoritos",
    add_email: "Agregar correo electrónico",
    select_header_file: "Seleccionar archivo de encabezado",
    select_footer_file: "Seleccionar archivo de pie de página",
    update_account: "Actualizar cuenta",
    more: "Más",
    clear_search: "Limpiar búsqueda",
    search: "Búsqueda",
    advanced_search: "Búsqueda avanzada",
    create: "Crear",
    create_favorite_list: "Crear lista de favoritos",
    add: "Añadir",
    confirm: "Confirmar",
    update: "Actualizar",
    confirm_delete: "Confirmar eliminación",
    confirm_remove: "Confirmar eliminación",
    next: "Siguiente",
    prev: "Anterior",
    add_funder: "Agregar financiador",
    close: "Cerrar",
    preview_document: "Vista previa del documento",
    submit: "Enviar",
    cancel: "Cancelar",
    resend_email: "Reenviar correo electrónico",
    confirm_purchase: "Confirmar compra",
    previous: "Anterior",
    watch_demo: "Ver demostración",
    learn_more: "Más información",
    filters: "Filtros",
    apply_filters: "Aplicar filtros",
    clear_filters: "Limpiar filtros",
    select_states: "Seleccionar estados",
    select_provinces: "Seleccionar provincias",
    select_counties: "Seleccionar condados",
    select_cities: "Seleccionar ciudades",
    yes_load_search: "Sí, cargar búsqueda",
    no_keep_current_search: "No, mantener búsqueda actual",
    yes_switch_search_type: "Sí, cambiar",
    no_keep_current_filters: "No, mantener filtros",
    search_options: "Opciones de búsqueda",
    apply: "Aplicar",
    remove_flag: "Eliminar bandera",
    save: "Guardar",
    claim_my_credits: "Reclamar mis créditos",
    copy_and_close: "Copiar y cerrar",
    send_notifications: "Enviar notificaciones",
    try_again: "Intentar de nuevo",
    forgot_password: "¿Olvidaste tu contraseña",
    no_keep_notification: "No, conservar notificación",
    yes_remove: "Sí, eliminar",
    view_qualifications: "Ver calificaciones",
    add_new_qualification: "Agregar nueva calificación",
    edit: "Editar",
    delete: "Eliminar",
    qualify_funder: "Calificar financiador",
    qualify_this_funder: "Calificar este financiador",
    add_qualification: "Agregar calificación",
    yes_delete: "Sí, eliminar",
    no_keep_qualification: "No, conservar calificación",
    start_editing: "Comenzar a editar",
    generate_with_ai: "Generar con IA",
    create_manually: "Crear manualmente",
    add_and_continue: "Agregar y continuar",
    continue_without_adding: "Continuar sin agregar",
    go_back: "Volver",
    no_keep_information: "No, conservar información",
  },
  input_fields: {
    press_enter: "Presiona Enter para agregar palabras clave",
  },
  tooltips: {
    to_country_filter: "Seleccionar uno o más países deshabilitará el filtro de estado",
    state_filter: "Seleccionar uno o más estados deshabilitará el filtro de país",
    county_filter: "Selecciona un estado para habilitar el filtro de condado. Deselecciona todas las ciudades para habilitar el filtro de condado",
    city_filter: "Selecciona un estado para habilitar el filtro de ciudad. Deselecciona todos los condados para habilitar el filtro de ciudad",
    custom_city_filter: "Selecciona un estado para habilitar el filtro de ciudad",
    cross_ref_location: "Con la Búsqueda de Referencia Cruzada activada, el Estado, Condado y Ciudad seleccionados aquí se aplican como filtros adicionales junto con sus términos de Referencia Cruzada — una donación debe dirigirse a esta ubicación (y aún coincidir con sus filtros de País y Año) para contar.",
    cross_ref_location_ca: "Con la Búsqueda de Referencia Cruzada activada, la Provincia y Ciudad seleccionadas aquí se aplican como filtros adicionales junto con sus términos de Referencia Cruzada — una donación debe dirigirse a esta ubicación (y aún coincidir con sus filtros de Año y Sector) para contar.",
    national_giving_interest_us_off: "Agrega financiadores que coinciden con sus términos de búsqueda y que han donado en al menos el número de estados seleccionado, aunque no hayan donado en el estado que eligió.",
    national_giving_interest_us_on: "Con la Búsqueda cruzada activada, Interés de donación nacional permite que los financiadores que donan en muchas ubicaciones sigan coincidiendo aunque la donación específica no esté en el estado, condado o ciudad seleccionados, siempre que coincida con sus términos de búsqueda, país, año y el término de búsqueda cruzada.",
    national_giving_interest_ca_off: "Agrega financiadores que coinciden con sus términos de búsqueda y que han donado en al menos el número de provincias seleccionado, aunque no hayan donado en la provincia que eligió.",
    national_giving_interest_ca_on: "Con la Búsqueda cruzada activada, Interés de donación nacional permite que los financiadores que donan en muchas ubicaciones sigan coincidiendo aunque la donación específica no esté en la provincia o ciudad seleccionada, siempre que coincida con sus términos de búsqueda, año, sector y el término de búsqueda cruzada.",
    min_grants_to_state: "Número mínimo de donaciones a organizaciones en cada estado seleccionado, en todo el historial de donaciones disponible.",
    business_ein: "¿Necesitas actualizar tu EIN/BN? Envía un correo a support@grantadvance.com con la información correcta y nuestro equipo lo gestionará por ti.",
    by_name: "Anteriormente: Por nombre",
    by_keyword: "Anteriormente: Por palabra clave",
    by_year: "Anteriormente: Por año",
    by_director: "Anteriormente: Por director",
    by_custom: "Anteriormente: Base de datos personalizada",
    target_beneficiaries: "Selecciona los grupos o personas que se beneficiarán directamente de este proyecto.",
    create_project_keyword: "Agrega palabras clave relevantes para clasificar y mejorar la visibilidad de tu proyecto.",
    similar_charities: "Busca organizaciones benéficas similares a este proyecto para que podamos encontrar financiadores que apoyen tu área.",
    other_funding_source: "Especifica cualquier fuente de financiamiento adicional para este proyecto, además de la subvención principal.",
    statistical_proof: "Proporciona datos o evidencia que respalden la necesidad y el impacto previsto de tu proyecto.",
    grant_advance_ai: "Nuestro modelo de IA utiliza los detalles de tu proyecto, como los beneficiarios objetivo, las palabras clave y la evidencia estadística. También puedes agregar información personalizada a estos campos según tus preferencias.",
    by_giving_history_info: "Busca el nombre de una organización benéfica para ver las fundaciones que la financian.",
    by_keyword_info: "Busca por palabras clave para ver financiadores que han donado a organizaciones cuyos nombres o descripciones contienen tus términos (resaltados en los resultados).",
    by_name_info: "Busca el nombre completo de un financiador o palabras clave relacionadas para ver perfiles que coincidan con tus términos.",
    by_director_info: "Busca el nombre de un director para encontrar los financiadores con los que está relacionado y consulta sus perfiles para ver las organizaciones que apoyan.",
    by_year_info: "Selecciona uno o más años para ver los financiadores que realizaron aportes durante esos años y consulta sus perfiles para ver las organizaciones que apoyaron.",
    by_custom_info: "Usa la búsqueda personalizada para filtrar resultados según tu propia base de datos.",
    by_international_info: "Busca en nuestras bases de datos globales para encontrar fundaciones que operan fuera de las fronteras de tu país.",
  },
  accountCreated: "Cuenta creada con éxito",
  accountDisabled: "Esta cuenta está deshabilitada. Para obtener más detalles, comuníquese con el administrador.",
  accountDisabledSuccess: "Cuenta deshabilitada con éxito",
  accountEnabledSuccess: "Cuenta habilitada con éxito",
  accountNotActivated: "Su cuenta no está activa. Por favor revise su correo electrónico para activar su cuenta",
  accountUpdatedSuccess: "Cuenta actualizada correctamente",
  additionalEmailNotFound: "Correo electrónico adicional no encontrado",
  additionalEmailRemovedSuccess: "Correo electrónico adicional eliminado con éxito",
  additionalEmailSavedSuccess: "Correo electrónico adicional guardado con éxito",
  additionalUserInsertSuccess: "Usuario adicional añadido con éxito",
  additionalUserUpdateSuccess: "Usuario adicional actualizado correctamente",
  additionalEmailLimit: "Solo puedes agregar hasta {{limit}} direcciones de correo electrónico adicionales. Elimina una existente si deseas agregar una nueva.",
  additionalEmailLimitShort: "Solo puedes agregar hasta {{limit}} direcciones de correo electrónico adicionales",
  addressBillingRequired: "Se requiere dirección de facturación",
  alertNotificationSavedSuccess: "Notificación de alerta guardada con éxito",
  cityBillingRequired: "Se requiere la ciudad de facturación",
  complementaryAddressBillingRequired: "Se requiere la dirección complementaria de facturación",
  confirmRegisterUserSuccess: "Gracias por confirmar tu correo electrónico",
  countryBillingRequired: "El país de facturación es obligatorio",
  countryNotFound: "País no encontrado",
  emailExists: "La dirección de correo ya existe",
  errorRegistration: "El modelo está vacío",
  expirationDateSavedSuccess: "Fecha de vencimiento guardada con éxito",
  footerImageRequired: "La imagen de pie de página es obligatoria",
  imageHeightLength: "Altura de imagen no válida",
  imageWidthLength: "Ancho de imagen no válido",
  invalidEmailAddress: "Dirección de correo electrónico no válida",
  invalidLetterType: "Tipo de carta no válido",
  invalidPhoneNumber: "Número de teléfono inválido",
  invalidSubscriptionPlan: "Plan de suscripción no válido",
  invalidUserRole: "Rol de usuario no válido",
  letterheadSavedSuccess: "Membrete guardado con éxito",
  licenseExpired: "Su licencia ha caducado. Para más detalles, póngase en contacto con el administrador",
  licenseNotFound: "No hay suficientes licencias disponibles. Póngase en contacto con support@grantadvance.com",
  loginFailed: "Usuario o contraseña inválido",
  masterOnly: "Solo los usuarios maestros tienen acceso a este recurso",
  notEnoughLicense: "Su organización no tiene ninguna licencia disponible. Si desea agregar licencias, haga clic aquí para comprar licencias adicionales",
  notificationExists: "La notificación ya existe",
  notificationNotFound: "Notificación no encontrada",
  funderQualifiedSuccess: "Financiador calificado correctamente",
  funderResetSuccess: "El financiador ha sido restablecido correctamente",
  funderDisqualifiedSuccess: "Financiador descalificado correctamente",
  funderPausedSuccess: "Calificación del financiador pausada correctamente",
  notificationTypeNotFound: "Tipo de notificación no encontrado",
  organizationDisabled: "Esta organización está deshabilitada. Para obtener más detalles, comuníquese con el administrador.",
  organizationMainAddressUpdatedSuccess: "Dirección principal de la organización actualizada con éxito",
  organizationNotFound: "Organización no encontrada",
  organizationProfileSavedSuccess: "Perfil de la organización guardado con éxito",
  passwordModified: "Contraseña modificada con éxito",
  passwordRecovery: "Por favor revise su correo electrónico para restablecer su contraseña.",
  passwordReset: "Contraseña restablecida con éxito",
  postalCodeBillingRequired: "El código postal de facturación es obligatorio",
  profileNotFound: "Perfil no encontrado",
  provinceOrStateBillingRequired: "Se requiere el estado/provincia de facturación",
  help_center: "Centro de ayuda",
  profile_settings: "Configuración del perfil",
  hi: "Hola",
  user_profile: "Perfil de usuario",
  logout: "Cerrar sesión",
  provinceOrStateNotFound: "Estado no encontrado",
  sendActivationLinkSuccess: "El correo electrónico de activación se ha enviado con éxito",
  sendPasswordResetSuccess: "El correo electrónico de restablecimiento de contraseña se ha enviado correctamente",
  sendSetupPasswordSuccess: "El correo electrónico de configuración de la contraseña se ha enviado correctamente",
  separatedLicenceExpirationDateError: "La fecha de vencimiento de las licencias separadas no puede ser posterior a la fecha de vencimiento de la licencia principal",
  settingUpAccountSuccess: "Su cuenta ha sido activada con éxito. Ahora puede iniciar sesión",
  signatureSavedSuccess: "Firma guardada con éxito",
  subscriptionPlanNotFound: "Plan de suscripción no encontrado",
  userLogoutSuccess: "Cierre de sesión del usuario con éxito",
  userNameExists: "Este nombre de usuario ya está en uso",
  userNotAllowed: "Usuario no autorizado para iniciar sesión",
  userNotFound: "Usuario no encontrado",
  userProfileSavedSuccess: "Perfil de usuario guardado con éxito",
  wrongCurrentPassword: "Contraseña actual incorrecta",
  additionalUsersRequired: "Se requieren los usuarios adicionales",
  addressRequired: "La dirección es requerida",
  amountDaysRequired: "Se requiere la cantidad de días",
  amountLicensesRequired: "La cantidad de licencias es obligatoria",
  planAmountRequired: "El monto del plan es obligatorio",
  amountMonthsRequired: "La cantidad de meses es obligatoria",
  amountYearsRequired: "La cantidad de años es obligatoria",
  billingAddressLine2Required: "Se requiere la dirección de facturación complementaria",
  billingAddressRequired: "La dirección de facturación es obligatoria",
  billingCityRequired: "La ciudad de facturación es obligatoria",
  billingCountryRequired: "El país de facturación es obligatorio",
  billingPostalCodeRequired: "El código postal de facturación es obligatorio",
  billingProvinceOrStateRequired: "Se requiere la provincia/estado de facturación",
  cityRequired: "Se requiere la ciudad",
  companyNameRequired: "El nombre de la empresa es obligatorio",
  businessEinRequired: "BN/EIN es obligatorio",
  compareConfirmPassword: "La contraseña y la contraseña de confirmación no coinciden.",
  complementaryAddressRequired: "Se requiere la dirección complementaria",
  confirmPasswordRequired: "Se requiere la contraseña de confirmación",
  countryRequired: "Se requiere el país",
  displayPlanRequired: "El plan de visualización es obligatorio",
  emailRequired: "El correo electrónico es obligatorio",
  firstNameRequired: "El primer nombre es obligatorio",
  headerImageRequired: "La imagen del encabezado es obligatoria",
  invalidEmail: "Este correo electrónico es inválido",
  invalidRole: "Rol de usuario no válido",
  lastNameRequired: "El apellido es obligatorio",
  licenseAmountRange: "El número de licencias debe ser mayor que cero",
  licenseRequired: "Se requiere la licencia",
  newPasswordRequired: "Se requiere la nueva contraseña",
  notificationTypeRequired: "Se requiere el tipo de notificación",
  oldPasswordRequired: "Se requiere la contraseña anterior",
  organizationIdRequired: "El ID de la organización es obligatorio",
  passwordLength: "Tu contraseña debe tener entre 6 y 20 caracteres",
  passwordRequired: "Se requiere la contraseña",
  phoneRequired: "El número de teléfono es obligatorio",
  planDescriptionRequired: "La descripción del plan es obligatoria",
  postalCodeRequired: "El código postal es obligatorio",
  provinceOrStateRequired: "Se requiere el estado/provincia",
  roleRequired: "El rol es requerido",
  signatureRequired: "Se requiere la firma",
  subscriptionPlanNameRequired: "Se requiere el plan de suscripción",
  tokenRequired: "Se requiere el token",
  userIdRequired: "Se requiere el ID de usuario",
  userNameRequired: "El correo electrónico de inicio de sesión es obligatorio",
  planNameRequired: "Se requiere el nombre del plan interno",
  customLetterRequired: "Se requiere la carta personalizada",
  customLetterSavedSuccess: "Carta personalizada guardada con éxito",
  customTagDeleteSuccess: "Etiqueta personalizada eliminada con éxito",
  customTagInsertSuccess: "Etiqueta personalizada creada con éxito",
  customTagNotFound: "Etiqueta personalizada no encontrada",
  customTagUpdateSuccess: "Etiqueta personalizada actualizada con éxito",
  documentStateInsertSuccess: "Estado del documento creado con éxito",
  inquiryLetterRequired: "Se requiere la carta de consulta",
  inquiryLetterSavedSuccess: "Carta de consulta guardada con éxito",
  proposalLetterRequired: "Se requiere la carta de propuesta",
  proposalLetterSavedSuccess: "Carta de propuesta guardada con éxito",
  userProjectRequired: "El proyecto de usuario es obligatorio",
  customDocumentTypeRequired: "El tipo de documento es obligatorio",
  documentAmountRequired: "La cantidad es requerida",
  documentFlaggedRequired: "La fecha es requerida",
  documentStateRequired: "El estado del documento es obligatorio",
  tagDescriptionRequired: "La descripción de la etiqueta es obligatoria",
  tagNameRequired: "El nombre de la etiqueta es obligatorio",
  blockedFundersDeleteAllSuccess: "Todos los financiadores se desbloquearon con éxito",
  blockedFundersDeleteSuccess: "Financiador desbloqueado con éxito",
  blockedFundersInsertSuccess: "Financiador bloqueado con éxito",
  blockedFundersNotFound: "Financiador bloqueado no encontrado",
  customDatabaseDeleteSuccess: "Base de datos personalizada eliminada con éxito",
  customDatabaseFieldsMapRequired: "Por favor, configure todos los campos obligatorios antes de continuar",
  customDatabaseNotFound: "Base de datos personalizada no encontrada",
  customDatabaseUserFieldsEmpty: "La lista de campos de configuración está vacía",
  favoriteDeleteSuccess: "Favorito eliminado con éxito",
  favoriteDuplicateSuccess: "Favorito duplicado con éxito",
  favoriteFundersDeleteSuccess: "Financiador favorito eliminado con éxito",
  favoriteFundersInsertSuccess: "{{funders}} financiadores agregados a {{favCount}} listas de favoritos",
  favoriteFundersNotFound: "Financiador favorito no encontrado",
  favoriteFundersUpdateSuccess: "Financiador favorito actualizado con éxito",
  favoriteInsertSuccess: "Favorito creado con éxito",
  favoriteNotFound: "Favorito no encontrado",
  favoriteUpdateSuccess: "Favorito actualizado con éxito",
  fundersListEmpty: "La lista de financiadores está vacía",
  noteDeleteSuccess: "Nota eliminada con éxito",
  noteInsertSuccess: "Nota creada con éxito",
  noteNotFound: "Nota no encontrada",
  noteUpdateSuccess: "Nota actualizada correctamente",
  noteRequired: "Se requiere una nota antes de adjuntar cualquier documento",
  notificationDateRequired: "La fecha de notificación es obligatoria",
  emailListRequired: "Seleccione el correo electrónico",
  customDatabaseFileRequired: "Se requiere el archivo de Excel",
  favoriteNameRequired: "El nombre del favorito es obligatorio",
  favoriteRequired: "Se requiere el favorito",
  foundationRequired: "Se requiere el financiador",
  jsonUserFieldsMapRequired: "Por favor, configure todos los campos obligatorios antes de continuar",
  labelTypeRequired: "El tipo de etiqueta es obligatorio",
  letterTypeRequired: "Seleccione el tipo de documento para imprimir",
  noteDescriptionRequired: "La descripción es obligatoria",
  noteTitleRequired: "El título es obligatorio",
  bundleInsertSuccess: "Paquete creado con éxito",
  bundleNotFound: "Paquete no encontrado",
  bundleTaskCount: "Ingrese al menos una tarea",
  bundleTaskNotFound: "No se pueden encontrar una o más tareas",
  flagDateRequired: "La fecha es requerida",
  flagUpdateSuccess: "Bandera actualizada con éxito",
  projectBudgetCategoryDescriptionRequired: "La descripción de la categoría es obligatoria",
  projectBudgetDeleteSuccess: "Presupuesto eliminado con éxito",
  projectBudgetDescriptionExists: "Esta descripción ya existe",
  projectBudgetInsertSuccess: "Presupuesto añadido con éxito",
  projectBudgetNotFound: "Presupuesto no encontrado",
  projectBudgetResetSuccess: "Presupuesto restablecido con éxito",
  projectBudgetUpdateSuccess: "Presupuesto actualizado correctamente",
  projectEndDateRequired: "La fecha de finalización es obligatoria",
  projectFundersDeleteSuccess: "Financiadores del proyecto eliminados con éxito",
  projectFundersEmpty: "Seleccione al menos un financiador antes de continuar",
  projectFundersInsertSuccess: "{{funderAmount}} financiadores agregados a {{projectName}}",
  projectStartDateRequired: "La fecha de inicio es obligatoria",
  taskDeleteSuccess: "Tarea eliminada con éxito",
  taskEditSuccess: "Tarea actualizada correctamente",
  taskInsertSuccess: "Tarea creada con éxito",
  taskListEmpty: "La lista de tareas está vacía",
  taskNotFound: "Tarea no encontrada",
  userProjectArchivedSuccess: "Proyecto de usuario archivado con éxito",
  userProjectDeleteSuccess: "Proyecto de usuario eliminado con éxito",
  userProjectEndDateRequired: "La fecha de finalización es obligatoria",
  userProjectInsertSuccess: "Proyecto de usuario creado con éxito",
  userProjectListEmpty: "Seleccione uno o más proyectos",
  userProjectNotFound: "Proyecto no encontrado",
  userProjectStartDateInvalid: "La fecha de inicio no es válida",
  userProjectStartDateRequired: "La fecha de inicio es obligatoria",
  userProjectUnarchivedSuccess: "Proyecto de usuario desarchivado con éxito",
  userProjectUpdateSuccess: "Proyecto de usuario actualizado con éxito",
  budgetTypeInvalid: "El tipo de presupuesto no es válido",
  bundleDescriptionRequired: "Se requiere la descripción del paquete",
  bundleNameRequired: "El nombre del paquete es obligatorio",
  bundleTaskRequired: "La lista de tareas es obligatoria",
  flagAmountInvalid: "La cantidad no es válida",
  flagAmountRequired: "La cantidad es requerida",
  flagStatusRequired: "El estado es obligatorio",
  foundationNameRequired: "El nombre del financiador es obligatorio",
  foundationSourceTypeRequired: "Se requiere la fuente del financiador",
  profileIdRequired: "El perfil es obligatorio",
  projectBudgetAmountRequired: "El monto del presupuesto es obligatorio",
  projectBudgetDescriptionRequired: "La descripción del presupuesto es obligatoria",
  projectCostInvalid: "El costo del proyecto no es válido",
  projectCostRequired: "Se requiere el costo del proyecto",
  projectDescriptionRequired: "Se requiere la descripción del proyecto",
  projectNameRequired: "El nombre del proyecto es obligatorio",
  projectStatusInvalid: "El estado del proyecto no es válido",
  taskDescriptionRequired: "La descripción de la tarea es obligatoria",
  taskNameRequired: "El nombre de la tarea es obligatorio",
  foundationInsertSuccess: "Financiador añadido con éxito",
  savedSearchDeleteSuccess: "Búsqueda eliminada con éxito",
  savedSearchDescriptionExists: "Esta descripción ya existe",
  savedSearchInsertSuccess: "Búsqueda agregada con éxito",
  savedSearchNotFound: "Búsqueda guardada no encontrada",
  savedSearchTypeInvalid: "El tipo de búsqueda guardada no es válido",
  savedSearchUpdateSuccess: "Búsqueda actualizada con éxito",
  descriptionRequired: "La descripción es obligatoria",
  jsonFieldsRequired: "El campo de búsqueda es obligatorio",
  searchTypeRequired: "El tipo de búsqueda es obligatorio",
  userProjectCompleted: "Este proyecto está marcado como completado",
  sendOnlineApplicationSuccess: "Mensaje de solicitud en línea enviado con éxito",
  sendSuggestionSuccess: "Sugerencia enviada con éxito",
  urlRequired: "La URL es obligatoria",
  fundersRemovedSuccess: "{{fundersRemoved}} financiador(es) han sido eliminados del proyecto actual",
  noteSubjectRequired: "El asunto es obligatorio",
  accountDeleted: "Esta cuenta fue eliminada. Contacte al administrador",
  userRemovedSuccess: "Cuenta eliminada con éxito",
  userNameOrEmailRequired: "El nombre de usuario o correo electrónico es obligatorio",
  fieldRequired: "Este campo es obligatorio",
  pickupNewPassword: "Por favor, elija una nueva contraseña",
  passwordMinCharacter: "Introduce al menos {{minimumCharaters}} caracteres",
  enterSameValueAgain: "Por favor, vuelva a introducir el mismo valor",
  feedbackSubmitted: "Comentarios enviados correctamente",
  feedbackInvalidGrantSize: "El tamaño de la subvención no es válido o es demasiado grande",
  feedbackReviewUpdated: "Revisión de comentarios actualizada",
  announcementTitleRequired: "El título del anuncio es obligatorio",
  announcementDescriptionRequired: "La descripción del anuncio es obligatoria",
  announcementReleaseDateRequired: "La fecha de publicación del anuncio es obligatoria",
  announcementReleaseDateInvalid: "No se permiten fechas pasadas para la fecha de publicación",
  announcementTypeRequired: "El tipo de anuncio es obligatorio",
  announcementNotFound: "Anuncio no encontrado",
  announcementInsertSuccess: "Anuncio agregado exitosamente",
  announcementUpdateSuccess: "Anuncio actualizado exitosamente",
  announcementDeleteSuccess: "Anuncio eliminado exitosamente",
  couponNameRequired: "El nombre del cupón es obligatorio",
  couponCodeRequired: "El código de cupón es obligatorio",
  couponCodeFormatInvalid: "El código de cupón no es válido",
  codeLengthInvalid: "Máximo de 15 caracteres",
  couponExpirationDateRequired: "Se requiere la fecha de vencimiento del cupón",
  couponExpirationMaxValue: "La fecha no puede ser mayor a 6 meses a partir de hoy",
  couponExpirationDateInvalid: "Fecha de vencimiento inválida",
  couponSubscriptionPlanRequired: "Se requiere el plan de suscripción del cupón",
  couponExtraMonthsAmountInvalid: "El mes extra solo permite del 1 al 99",
  couponDiscountAmountInvalid: "El descuento solo permite del número 1 al 90",
  couponCodeAlreadyExist: "El código del cupón ya ha sido canjeado",
  couponSubscriptionNotFound: "Plan de suscripción no encontrado",
  couponNotFound: "Cupón no encontrado",
  couponSelectType: "Selecciona al menos un tipo de cupón (Tiempo extra/Descuento y/o Desbloquear planes)",
  couponInsertSuccess: "Cupón agregado exitosamente",
  couponUpdateSuccess: "Cupón actualizado exitosamente",
  couponDeleteSuccess: "Cupón eliminado exitosamente",
  couponPauseUpdateSuccess: "Cupón actualizado exitosamente",
  deadlineEINRequired: "El EIN es obligatorio",
  deadlineFoundationNameRequired: "El nombre del financiador es obligatorio",
  deadlineCategoryRequired: "La categoría es obligatoria",
  deadlineURLRequired: "Se requiere la URL de la fecha límite",
  deadlineCountryRequired: "El país es obligatorio",
  deadlineDateInvalid: "Solo se permiten fechas futuras",
  deadlineAmountToobig: "El monto de la subvención es demasiado grande",
  deadlineImportSuccess: "{{fileName}} importado con éxito",
  deadlineImportSuccessWithWarning: "El archivo se ha importado correctamente. Sin embargo, algunos elementos tienen datos no válidos. Por favor, actualícelos",
  deadlineUpdateSuccess: "Fecha límite actualizada correctamente",
  deadlineDeleteSuccess: "Fecha límite eliminada con éxito",
  deadlineRemovePopupMessage: "Esta acción eliminará esta fecha límite",
  deadlineReviewCorrectInformation: "Por favor revisa y corrige la información",
  deadlineInvalidFoundationDataField: "Los datos proporcionados del financiador contienen una entrada no válida para el campo {{invalidData}}.",
  deadlineInvalidFoundationDataFields: "Los datos proporcionados del financiador contienen entradas no válidas para los siguientes campos: {{invalidData}}.",
  deadlineImportFilePrompt: "¿Quieres importar este archivo?",
  thankYouLetterSavedSuccess: "Carta de agradecimiento guardada con éxito",
  impactReportLetterSavedSuccess: "Carta de informe de impacto guardada con éxito",
  historyTypeRequired: "El tipo de historial es obligatorio",
  startDateRequired: "La fecha de inicio es obligatoria",
  startDateInvalid: "Seleccione una fecha que sea posterior a la de hoy",
  dateMin: "Por favor seleccione una fecha mayor a la de hoy",
  referralNameCharityRequired: "El nombre de la organización benéfica es obligatorio",
  referralNameContactRequired: "El nombre del contacto es obligatorio",
  referralSubmitted: "Referencia enviada exitosamente. Recomendar otra organización benéfica",
  templateApplying: "Aplicando, por favor espere...",
  templateApplyWarning: "La aplicación puede llevar unos minutos",
  historyTimeline: {
    funderAdded: "Financiador agregado al proyecto",
    funderRemoved: "Financiador eliminado del proyecto",
    noteAdded: "Nota añadida",
    foundationProfileView: "Perfil del financiador visto en el proyecto",
    customDoc: "Documento personalizado",
    masterDoc: "Documento maestro",
    createdOnProject: "creado en el proyecto",
    deletedOnProject: "eliminado del proyecto",
    statusUpdated: "Estado actualizado a",
    onProject: "en el proyecto",
  },
  passwordNotMatch: "La contraseña ingresada no coincide",
  emailAlreadyExist: "Esa dirección de correo electrónico ya está registrada. Por favor, <a href='/' style='color: #02958a'>inicia sesión</a>",
  licenseRenewSuccess: "Su solicitud de renovación de licencia se ha enviado correctamente. Nuestro equipo administrativo la procesará en breve.",
  grantAmountRequired: "Se requiere el monto de la subvención",
  purposeRequired: "Se requiere el propósito",
  dateAwardedRequired: "Se requiere la fecha de adjudicación",
  shareConsentRequired: "Debe aceptar los términos requeridos para continuar.",
  reportGrantSubmitted: "Su informe de subvención ha sido enviado exitosamente",
  alertTitleRequired: "El título de la alerta es obligatorio",
  passwordInvalid: "Contraseña incorrecta, inténtalo de nuevo",
  allAssignedLicensesActive: "Todas las licencias asignadas están activas",
  someAssignedLicensesNotActive: "Algunas licencias asignadas no están activas",
  switchMainUserLicenseSuccess: "La licencia de usuario principal se ha cambiado correctamente.",
  licenseDeletedSuccessfuly: "Licencia eliminada correctamente",
  errorDeletingLicense: "Error al eliminar la licencia",
  upgradeDemoAccountSuccess: "Actualización de la cuenta demo completada con éxito",
  skipPaymentReasonRequired: "The reason is required",
  funderQualificationInsertSuccess: "Calificación del financiador agregada correctamente",
  funderQualificationUpdateSuccess: "Calificación del financiador actualizada correctamente",
  funderQualificationDeleteSuccess: "Calificación del financiador eliminada correctamente",
  sectorInsertSuccess: "Sector agregado correctamente",
  grantTypeInsertSuccess: "Tipo de subvención agregado correctamente",
  stepStatusUpdated: "Estado de revisión actualizado correctamente",
  missionStatementTooLong: "La declaración de misión no puede superar los 5,000 caracteres.",
  accountOwnershipChangedSuccess: "La transferencia de propiedad se realizó correctamente.",
  demoAccountDeletedSuccess: "Cuenta de demostración eliminada correctamente.",
  websiteInvalid: "Este sitio web no es válido."
};